/**
 * EliorGroup.Joyfood.B2B2C API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DietDto } from './dietDto';
import { AllergenDto } from './allergenDto';
import { CondimentsDto } from './condimentsDto';


export interface CustomerPreferencesDto { 
    diets?: Array<DietDto> | null;
    allergens?: Array<AllergenDto> | null;
    condiments?: Array<CondimentsDto> | null;
}

